module.exports = __webpack_public_path__ + "media/images/login/login_t2-d8fa502a7aee94a82f7d13c0bca53807.gif";